const typeDict = {
  31: 'Входящее',
  32: 'Исходящее',
};

export const type = (val) => typeDict[val];
